import styled from 'styled-components/macro'

export const ButtonsS = styled.div`
  display: flex;
  flex-flow: row nowrap;
`
